// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__MMICv","crumbs":"breadcrumb_crumbs__-KvTP","currentPage":"breadcrumb_currentPage__WW6Ej"};